import "./Style.scss";
import ChangePassword from "./ChangePassword";
import Profile from "./Profile";
import Account from "./Account";

export { ChangePassword, Profile, Account };
